import { GridBaseDataProvider } from '../../../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, RuleSetItem } from '../types';
import { GetRowsRequest } from '../../../../../grid/types/common';

export class IntegrityMonitorPolicyRuleSetsGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  constructor(private ruleSetItems: Array<RuleSetItem>) {
    super();
  }

  get ruleSets(): Array<RuleSetItem> {
    return this.ruleSetItems;
  }

  set ruleSets(value: Array<RuleSetItem>) {
    this.ruleSetItems = value;
  }

  async getSummary() {
    return {
      summary: '',
      numItems: this.ruleSetItems.length,
    };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<{ rawEvents: Array<RuleSetItem> }> {
    return {
      rawEvents: this.ruleSetItems.map(item => {
        return {
          ...item,
          actions: true,
        };
      }),
    };
  }
}
